import clsx from 'clsx'
import { useMediaQuery } from 'react-responsive'

interface FixedBottomContainerProps {
  children: React.ReactNode
}

/**
 * Wrapper component providing background, padding, shadow and
 * fixed to the bottom of the screen. Provide your own children.
 *
 * @example
 * <FixedBottomContainer>
 *     <div class="flex gap-4">
 *         <Button>Request Sample</Button>
 *         <Button>Add to cart</Button>
 *     </div>
 * </FixedBottomContainer>
 *
 * @component
 */
const FixedBottomContainer: React.FC<FixedBottomContainerProps> = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 })
  return (
    <div
      className={clsx(
        'fixed left-auto right-auto max-w-[500px] w-full bottom-0 bg-white py-[10px] px-4 shadow-[0_-6px_14px_rgba(132,77,77,0.1)] z-20',
        !isMobile && 'max-w-full left-0'
      )}
    >
      {children}
    </div>
  )
}

export default FixedBottomContainer
